import { queryKey } from '../../utils/queryUtils';

export const configKey = queryKey('config');
